import { makeAutoObservable, runInAction } from 'mobx'

/**
 * 只是一个模板，没有实际业务价值
 */
class CustomStore {
  private _prop: number = 0

  constructor() {
    makeAutoObservable(this)
  }

  get prop() {
    return this._prop
  }

  set prop(value: typeof this._prop) {
    runInAction(() => {
      this._prop = value
    })
  }
}

export const customStore = new CustomStore()
